<div class="account-card" *ngIf="!errorMessage && tokenDetails as data">
  <div class="header">
    <div class="title-wrapper">
      <h3>{{ data.lottery.name }}</h3>
      <span class="badge">{{ data.lottery.status }}</span>
    </div>
    <button (click)="onClose('cancel')" class="close-btn">&times;</button>
  </div>
  <div class="token-banner">
    <small>Total Earned Tokens</small>
    <div class="count">{{ data.assignedTokens }}</div>
  </div>
  <div class="rewards-container">
    <div class="reward-section gold-section">
      <h4 class="section-title">Gold Rewards</h4>
      <div class="stat-group">
        <div class="stat-row">
          <span class="title">Gold Weight per Token</span>
          <strong class="badge gold-badge">{{ data.lottery.goldWeightInGramsPerToken }}g</strong>
        </div>
        <div class="stat-row">
          <span class="title">Purchased Gold Weight</span>
          <strong>{{ data.accumulatedGoldWeightInGrams }}g</strong>
        </div>
      </div>
    </div>

    <div class="reward-section silver-section">
      <h4 class="section-title">Silver Rewards</h4>
      <div class="stat-group">
        <div class="stat-row">
          <span class="title">Silver Weight per Token</span>
          <strong class="badge silver-badge">{{ data.lottery.silverWeightInGramsPerToken }}g</strong>
        </div>
        <div class="stat-row">
          <span class="title">Purchased Silver Weight</span>
          <strong>{{ data.accumulatedSilverWeightInGrams }}g</strong>
        </div>
      </div>
    </div>
    <div *ngIf="data.requiredGoldWeightInGramsForNextToken" class="required-section">
      <h4 class="required-title">Required Weight for next Token (GOLD/SILVER)</h4>
      <div class="stat-group">
        <div class="stat-row">
          <span class="title">Gold Weight</span>
          <strong>{{ data.requiredGoldWeightInGramsForNextToken }}g</strong>
        </div>
        <div class="stat-row">
          <span class="title">Silver Weight</span>
          <strong>{{ data.requiredSilverWeightInGramsForNextToken }}g</strong>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="account-card error-card" *ngIf="errorMessage">
  <div class="header">
    <button (click)="onClose('cancel')" class="close-btn">&times;</button>
  </div>
  <div class="error-message">
    <h4>{{ errorMessage }}</h4>
  </div>
</div>
